export const getDefaultMinimumMonthlyBudget = (currency: string): number => {
  switch (currency) {
    case "CZK":
      return 3000;
    case "EUR":
      return 120;
    default:
      return 3000; // Default to CZK if currency is unknown
  }
};
